(()=>{
  if(window.bbcCartBadge)return;window.bbcCartBadge=true;
  const mounted=new WeakSet();
  const init=()=>document.querySelectorAll('.CartCountBadge').forEach(badge=>{
    if(mounted.has(badge))return;mounted.add(badge);
    let previous=Number(badge.textContent)||0;
    const link=badge.closest('a'),label=link?.getAttribute('aria-label')||'Open cart';
    const update=()=>{
      const count=Number(badge.textContent)||0;
      badge.classList.toggle('is-visible',count>0);
      if(link)link.setAttribute('aria-label',label+' ('+count+')');
      if(count>previous&&!matchMedia('(prefers-reduced-motion: reduce)').matches){badge.classList.remove('CartCountBadge--pulse');void badge.offsetWidth;badge.classList.add('CartCountBadge--pulse');}
      previous=count;
    };
    badge.addEventListener('animationend',()=>badge.classList.remove('CartCountBadge--pulse'));
    new MutationObserver(update).observe(badge,{childList:true,characterData:true,subtree:true});update();
  });
  document.addEventListener('shopify:section:load',init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
